var map = {
	"./Bitmap.png": "8189",
	"./Johnni.jpg": "4d4e",
	"./LS_Guide.mp4": "2b79",
	"./LS_painting.mp4": "aaad",
	"./Langkah Sheraton Video 01.mp4": "8de2",
	"./OILPAINT3.png": "a558",
	"./Shalini.jpg": "01f3",
	"./Techtics.png": "9bcd",
	"./about.jpg": "c89a",
	"./about.png": "ce1b",
	"./about01.jpg": "f622",
	"./about02.jpg": "90a7",
	"./about03.jpg": "2077",
	"./about04.jpg": "37686",
	"./about05.jpg": "e1c1",
	"./artist1.jpg": "c867",
	"./artist2.jpg": "8d8d",
	"./artist3.jpg": "dab6",
	"./artist4.jpg": "748b",
	"./artist5.jpg": "1915",
	"./button.png": "e15b",
	"./caret-left-solid.png": "0c35",
	"./caret-left-solid.svg": "b159",
	"./caret-right-solid.png": "aa6d",
	"./caret-right-solid.svg": "7ac6",
	"./dao-logo-old.svg": "8bf3",
	"./dao-logo.svg": "abcb",
	"./dap.jpg": "6bea",
	"./dap.png": "f55e",
	"./dap1.jpg": "0b92",
	"./dap2.jpg": "f52c",
	"./dap3.jpg": "abc8",
	"./dap4.jpg": "818b",
	"./dap5.jpg": "1c8d",
	"./discord-logo.png": "01a2",
	"./discord.png": "a379",
	"./fermion.png": "87ba",
	"./footer.png": "68f2",
	"./groupPhoto.png": "adb1",
	"./header.png": "b783",
	"./header2.png": "070e",
	"./home-top-bg.png": "8239",
	"./home.jpg": "9750",
	"./icon-discord.png": "03da",
	"./icon-email.png": "47b3",
	"./icon-website.png": "451e",
	"./icon1.png": "1b1b",
	"./icon2.png": "32e9",
	"./icon3.png": "d7cf",
	"./iconDemo.png": "4cdd",
	"./iconDisc.png": "a187",
	"./iconEqual.png": "515b",
	"./iconNotif.png": "be5f",
	"./iconStar.png": "270a",
	"./iconValue.png": "ed7a",
	"./logout.png": "cb7b",
	"./ls_video.mp4": "9aaa",
	"./metamask.png": "8b79",
	"./modal1.png": "3791",
	"./modal2.png": "afa2",
	"./modal3.png": "605c",
	"./modal4.png": "42cb",
	"./modal5.png": "203c",
	"./mxo.png": "7754",
	"./nav-side.png": "0d60",
	"./nft.png": "599a",
	"./nft/12 stage property.jpg": "9b53",
	"./nft/3_Budaya Politik Matang.jpg": "5b39",
	"./nft/3_WKS hand.jpg": "4123",
	"./nft/3_buku harapan.jpg": "7e88",
	"./nft/3_cabinet.jpg": "d334",
	"./nft/3_chess.jpg": "3e78",
	"./nft/3_hadi fish.jpg": "0c8c",
	"./nft/3_muhyiddin knife.jpg": "1826",
	"./nft/3_muhyiddin3.jpg": "e218",
	"./nft/3_parlimen.jpg": "79f4",
	"./nft/3_treasure chest3.jpg": "41e9",
	"./nft/3bn.jpg": "eaeb",
	"./nft/3ph.jpg": "1607",
	"./nft/4_hishamuddin shirt.jpg": "8af9",
	"./nft/4_sheraton.jpg": "acc8",
	"./nft/5leader.jpg": "210a",
	"./nft/Azmin_key.jpg": "b69e",
	"./nft/LGE_3.jpg": "15f5",
	"./nft/LKS.jpg": "0167",
	"./nft/LKS_3.jpg": "d972",
	"./nft/LKS_eyes.jpg": "558c",
	"./nft/LKS_mouth.jpg": "ef83",
	"./nft/LV shoe.jpg": "ff4c",
	"./nft/Mahathir.jpg": "2134",
	"./nft/Mahathir_3.jpg": "791e",
	"./nft/Mahathir_eyes.jpg": "49f4",
	"./nft/Mahathir_mouth.jpg": "008f",
	"./nft/Mat Sabu.jpg": "080c",
	"./nft/Mat Sabu_3.jpg": "1d54",
	"./nft/Mat Sabu_eyes.jpg": "96e6",
	"./nft/Mat Sabu_mouth.jpg": "1ec2",
	"./nft/WKS.jpg": "7de8",
	"./nft/WKS_3.jpg": "c7ea",
	"./nft/WKS_eyes.jpg": "8a13",
	"./nft/WKS_mouth.jpg": "624c",
	"./nft/Zulaida.jpg": "cb4c",
	"./nft/Zulaida_3.jpg": "c4ee",
	"./nft/Zulaida_eyes.jpg": "8468",
	"./nft/Zulaida_mouth.jpg": "95bb",
	"./nft/all_eye.jpg": "eeae",
	"./nft/all_head copy.jpg": "0640",
	"./nft/all_head_black copy.jpg": "607a",
	"./nft/all_mouth.jpg": "6456",
	"./nft/anwar.jpg": "160c",
	"./nft/anwar_3.jpg": "e0df",
	"./nft/anwar_eyes.jpg": "d639",
	"./nft/anwar_mouth.jpg": "5344",
	"./nft/azmin.jpg": "551f",
	"./nft/azmin_3.jpg": "d38c",
	"./nft/azmin_eyes.jpg": "e2ec",
	"./nft/azmin_mouth.jpg": "6bfc",
	"./nft/azmin_zuraida.jpg": "858c",
	"./nft/backdoor.jpg": "4922",
	"./nft/bn_side copy.jpg": "2ecb",
	"./nft/buku harapan.jpg": "7f37",
	"./nft/cabinet.jpg": "6d01",
	"./nft/call.jpg": "a0ef",
	"./nft/covid pattern.jpg": "344c",
	"./nft/covid.jpg": "2859",
	"./nft/flower_pattern.jpg": "84e6",
	"./nft/full_artwork.jpg": "08f8",
	"./nft/full_black.jpg": "fe93",
	"./nft/full_black2.jpg": "bc5a",
	"./nft/full_blue.jpg": "0288",
	"./nft/full_green.jpg": "df2f",
	"./nft/full_lightblue.jpg": "1ad6",
	"./nft/full_orange.jpg": "3e87",
	"./nft/full_red.jpg": "cf2a",
	"./nft/hadi.jpg": "8e1e",
	"./nft/hadi_3.jpg": "1eb5",
	"./nft/hadi_eyes.jpg": "6a18",
	"./nft/hadi_mouth.jpg": "ed08",
	"./nft/hand.jpg": "833d",
	"./nft/head_color.jpg": "8e8a",
	"./nft/hishamuddin.jpg": "bab4",
	"./nft/hishamuddin_3.jpg": "b661",
	"./nft/hishamuddin_eyes.jpg": "c668",
	"./nft/hishamuddin_mouth.jpg": "5b52",
	"./nft/item_color.jpg": "77e1",
	"./nft/lim guan eng.jpg": "8d2f",
	"./nft/lim guan eng_eyes.jpg": "cf83",
	"./nft/lim guan eng_mouth.jpg": "c606",
	"./nft/lks_speaker_najib.jpg": "f387",
	"./nft/ma_anwar.jpg": "a83c",
	"./nft/ma_najib.jpg": "149e",
	"./nft/muhyiddin.jpg": "a491",
	"./nft/muhyiddin_3.jpg": "2cd4",
	"./nft/muhyiddin_eyes.jpg": "a894",
	"./nft/muhyiddin_mouth.jpg": "e741",
	"./nft/najib.jpg": "f7f0",
	"./nft/najib_3.jpg": "1c5c",
	"./nft/najib_eyes.jpg": "d6f5",
	"./nft/najib_mouth.jpg": "6ab9",
	"./nft/najib_zahid.jpg": "6204",
	"./nft/parliamen_logo.jpg": "bf23",
	"./nft/parlimen Malaysia.jpg": "61d0",
	"./nft/ph_side copy.jpg": "e772",
	"./nft/shafie.jpg": "e33e",
	"./nft/shafie_3.jpg": "e231",
	"./nft/shafie_eyes.jpg": "bf4e",
	"./nft/shafie_mouth.jpg": "df4b",
	"./nft/speaker_eyes.jpg": "48a7",
	"./nft/spesker.jpg": "08ec",
	"./nft/spesker_3.jpg": "3c4d",
	"./nft/spesker_mouth.jpg": "26d5",
	"./nft/tony_artwork.jpg": "3233",
	"./nft/zahid.jpg": "1759",
	"./nft/zahid_3.jpg": "e3f7",
	"./nft/zahid_eyes.jpg": "4c36",
	"./nft/zahid_mouth.jpg": "f5a1",
	"./nft/zuraida_wks.jpg": "3aa7",
	"./nft1.png": "9367",
	"./nft2.png": "1147",
	"./nft3.png": "4e08",
	"./oilpaint1.png": "016d",
	"./oilpaint2.png": "3354",
	"./origin.jpeg": "df3c",
	"./origin.png": "a2e3",
	"./origin1.jpg": "0291",
	"./origin2.jpg": "9d12",
	"./origin3.jpg": "fbfb",
	"./origin4.jpg": "26b4",
	"./origin5.jpg": "6865",
	"./painting1.jpg": "28bb",
	"./painting2.jpg": "57e2",
	"./painting3.jpg": "0d93",
	"./painting4.jpg": "0900",
	"./painting5.jpg": "cab0",
	"./polling.png": "fedd",
	"./polling_new.png": "1844",
	"./techtics.jpeg": "3b32",
	"./techtics2.png": "5f2e",
	"./techtics_crop.png": "9b02",
	"./techtics_logo.png": "76fc",
	"./the-edge.png": "86d6",
	"./tick.png": "bb22",
	"./tnc/tnc1.jpg": "6106",
	"./tnc/tnc10.jpg": "2e61",
	"./tnc/tnc2.jpg": "ffa8",
	"./tnc/tnc3.jpg": "58d7",
	"./tnc/tnc4.jpg": "7955",
	"./tnc/tnc5.jpg": "69bb",
	"./tnc/tnc6.jpg": "8dd5",
	"./tnc/tnc7.jpg": "9251",
	"./tnc/tnc8.jpg": "c981",
	"./tnc/tnc9.jpg": "d4be",
	"./tony_artist.jpg": "8e1d",
	"./unnamed (1).png": "a0b0",
	"./unnamed (2).png": "49ff",
	"./unnamed (3).png": "02a9",
	"./unnamed (4).png": "6640",
	"./unnamed.png": "0c90",
	"./video.mp4": "84df",
	"./wallet-logo.png": "8f68",
	"./wallet.png": "bb7d",
	"./wallet_connect.png": "03a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95cd";